<template>
    <div class="d-flex justify-content-between align-items-center">
        <span v-if="editing === false">{{ currentTitle }}</span>
        <input
            class="form-control"
            v-if="editing"
            v-model="newTitle"
            :placeholder="placeholder"
            :readonly="loading === true"
            v-on:blur="updateTitle"
            v-on:keyup.enter="updateTitle"
            v-on:keyup.esc="refresh"
        />
        <button class="btn btn-sm btn-outline-secondary" v-if="editing === false" v-on:click="editing = true">
            <i class="fa fa-fw fa-pencil-alt"></i>
        </button>
    </div>
</template>

<script>
import axios from 'axios';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        currentTitle: String,
        placeholder: String,
        route: String,
        uuid: String,
    },
    data () {
        return {
            editing: false,
            loading: false,
            newTitle: '',
        };
    },
    mounted () {
        this.newTitle = this.currentTitle;
    },
    methods: {
        refresh () {
            // needs to be this way as Eventbus is not defined in component
            Eventbus.emit('files-table-refresh');
        },
        updateTitle () {
            this.loading = true;
            axios.post(
                this.route.replace('replace-me', this.uuid),
                {
                    title: this.newTitle
                }
            ).then((response) => {
                // reloading the table will remove the component
                // so no need to worry about setting loading to false here
                Eventbus.emit('files-table-refresh');
            }).catch((error) => {
                // allow retries here though
                this.loading = false;
                let status = 'Unknown';
                if (error.response) {
                    status = error.response.status;
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Could not update title',
                    text: 'System error: ' + status,
                });
            });
        }
    }
};
</script>
